import { Schema } from '@core/data/dto/schema';

export const BenefitSchema = {
    id: Schema.String,
    provider: Schema.String,
    provider_id: Schema.String,
    period: Schema.Auto,
    description: Schema.String,
    effective_start: Schema.Moment,
    effective_end: Schema.Moment,
    company_contribution_amount: Schema.Number,
    company_contribution_percent: Schema.Number,
    company_period_amount: Schema.Number,
    employee_contribution_amount: Schema.Number,
    employee_contribution_percent: Schema.Number,
    employee_period_amount: Schema.Number,
    hsa_contribution_limit: Schema.Number
}
